// Chaque mot que le joueur peut lire, en français.
//
// Le fichier anglais est la source de vérité : i18n.js s'y replie pour toute clé qui
// n'est pas encore traduite ici, donc une traduction à moitié faite montre de l'anglais
// dans les trous plutôt que des blancs ou des noms de clés.
//
// Les clés sont à plat et pointées exprès : `ach.veteran.name` se lit pareil dans chaque
// table, et une recherche de la clé trouve à la fois l'endroit où on l'utilise et la
// traduction.

export default {
  // --- chrome --------------------------------------------------------------
  // La descripción que sale en Google y al pegar el enlace en un chat. Vive aquí y no escrita
  // en el HTML porque el HTML se genera por idioma en el build (ver tools/prerender-langs.mjs).
  'seo.description': 'Le classique du lancer de bananes, refait et multijoueur : artillerie au tour par tour sur un skyline néon. Contre l\'IA, sur le même clavier ou par code avec un ami. Gratuit et en six langues.',
  'app.tagline': 'Le classique du lancer de bananes, refait et multijoueur.',
  'app.footer': 'Créé par Mendo Network, avec amour et beaucoup de nostalgie.',
  'ad.label': 'Publicité',
  'ad.tag': 'PUBLICITÉ',
  'app.canvasLabel': 'Champ de bataille : horizon néon avec deux gorilles qui lancent des bananes',
  'app.language': 'LANGUE',

  'title.start': '▶ JOUER',
  'title.join': '▶ REJOINDRE',

  'menu.title': 'MENU PRINCIPAL',
  'menu.resume': '▶ REVENIR À LA PARTIE',
  'menu.newMatch': '▶ NOUVELLE PARTIE',
  'menu.play': '▶ NOUVELLE PARTIE',
  'menu.characters': '🎨 PERSONNAGE',
  'menu.leaderboards': '🏆 CLASSEMENTS',
  'menu.back': '← RETOUR À L’ACCUEIL',
  'menu.awards': '🏆 SUCCÈS',

  'setup.title': 'RÉGLAGES DE LA PARTIE',
  'setup.mode': 'MODE',
  'setup.players': 'JOUEURS',
  'setup.turn': 'TEMPS DE TOUR',
  'setup.noLimit': 'SANS LIMITE',
  'setup.target': 'MANCHES DE LA PARTIE',
  'setup.onePlayer': '🤖 1 JOUEUR',
  'setup.twoPlayers': '👥 2 JOUEURS',
  'setup.back': '← RETOUR',
  'setup.start': '▶ COMMENCER',

  'pause.title': 'EN PAUSE',
  'pause.turn': 'À {name} DE LANCER',
  'pause.resume': '▶ REPRENDRE',
  'pause.restart': '↻ RECOMMENCER',
  'pause.setup': '🎮 RÉGLAGES',
  'pause.share': '🔗 INVITER',
  'pause.home': '🚪 TERMINER LA PARTIE',
  'pause.menu': '⌂ RETOUR AU MENU PRINCIPAL',
  'pause.music': 'MUSIQUE',
  'pause.fx': 'EFFETS',
  'setup.against': 'L’AUTRE CAMP',
  'setup.againstCpu': '🤖 L’ORDINATEUR',
  'setup.againstRandom': '🎲 ADVERSAIRE AU HASARD',
  'pool.waiting': '{n} EN ATTENTE',
  'pool.playing': '{n} EN PARTIE · {w} EN ATTENTE',
  'pool.none': 'PERSONNE N’ATTEND POUR LE MOMENT',
  'pool.noserver': 'PAS DE SERVEUR · VOUS JOUEREZ CONTRE L’ORDINATEUR',
  'search.title': 'RECHERCHE D’UN ADVERSAIRE',
  'search.empty': 'LA FILE EST VIDE · VOUS JOUEREZ CONTRE L’ORDINATEUR',
  'search.seconds': '{n} s',
  'search.matched': '{name} EST ARRIVÉ',
  'search.cpu': '🤖 JOUER CONTRE L’ORDINATEUR',
  'search.cancel': '✖ ANNULER',
  'special.sheep.name': 'MOUTON',
  'special.sheep.hint': 'Saute tout seul et explose.',
  'play.fireSheep': '🐑 MOUTON !',
  'bubble.sheep': 'BÊÊÊ !',
  'char.you': 'VOUS',
  'char.rival': 'ADVERSAIRE',
  'hud.vsOnline': 'VS {name}',
  'music.on': 'MUSIQUE OUI',
  'music.off': 'MUSIQUE NON',
  'pause.button': 'Pause',

  'results.over': 'PARTIE TERMINÉE',
  'results.wins': '{name} GAGNE',
  'results.rematch': '▶ REVANCHE',

  // --- the header and the play bar ----------------------------------------
  'hud.vsCpu': 'VS ORDI',
  'hud.twoPlayer': '2 JOUEURS',
  'hud.firstTo': 'PREMIER À',
  'hud.round': 'MANCHE {n}',
  'hud.noRound': 'MANCHE —',
  'hud.p1': 'J1',
  'hud.p2': 'J2',
  'hud.cpu': 'ORDI',
  'hud.wind': 'VENT',

  'play.angle': 'ANGLE',
  'play.power': 'FORCE',
  'play.fire': 'LANCER',
  'play.waiting': "EN ATTENTE DE L'ADVERSAIRE",
  'play.fireBall': 'LANCER LA BALLE',
  'play.fireGrenade': 'LANCER LA GRENADE',
  'play.fireLeap': 'SAUTER ET LANCER',
  'play.fireShield': 'LEVER LE BOUCLIER',
  'play.fireSpring': 'MONTER SUR LE RESSORT',
  'play.fireMushroom': 'GARDER LE CHAMPIGNON',


  // --- the special button --------------------------------------------------
  'special.none': '✦ SPÉCIAL : AUCUN',
  'special.spent': '✦ SPÉCIAL : ÉPUISÉ',
  'special.locked': '✦ SPÉCIAL : VERROUILLÉ',
  'special.off': 'PAS DE SPÉCIAUX',
  'special.chosen': '✦ {name} × {n}',

  // --- panels --------------------------------------------------------------
  'loadout.title': '🎒 ÉQUIPEMENT',
  'loadout.note': 'Ce que vous portez : ce que vous choisissez est ce que fait votre prochain lancer, et une protection se lève avec le bouton du bouclier. (La touche I ouvre ceci.)',
  'intro.welcome': '{n} CAPACITÉS PRÊTES — ⚔ ATTAQUE EN CHOISIT UNE',
  'loadout.next': 'Gardé pour votre prochain tour.',
  'loadout.ults': 'ATTAQUES SPÉCIALES',
  'loadout.guards': 'DÉFENSES',
  'loadout.howto': 'Succès : {name}',
  'loadout.off': 'Ni attaques spéciales ni défenses dans ce mode : CLASSIQUE est le jeu d’origine.',
  'special.attack': '⚔ ATTAQUE',
  'special.guard': '🛡 DÉFENSE',
  'announce.round': 'MANCHE {n}',
  'announce.fight': 'BATTEZ-VOUS !',
  'announce.turn': 'À VOUS — {name}',
  'splash.tapForMusic': 'TOUCHEZ POUR ENTENDRE LA MUSIQUE',
  'char.title': '🎨 PERSONNAGES',
  'char.close': '✕ FERMER',
  'char.save': '✓ ENREGISTRER',
  'char.note': 'Espèces et accessoires. Un animal plus large est une cible plus large, et un haut-de-forme une tête un peu plus grande : le dessin est la zone de touche.',
  'char.player1': 'JOUEUR 1',
  'char.player2': 'JOUEUR 2',
  'slot.hat': 'CHAPEAU',
  'slot.face': 'VISAGE',
  'slot.neck': 'COU',

  'award.title': '🏆 SUCCÈS',
  'award.close': '✕ FERMER',
  'award.progress': '🏆 SUCCÈS {n}/{total}',
  'award.rewardAntic': '+ GESTE {name}',
  'award.rewardSpecial': '+ SPÉCIAL {name}',

  'rank.title': '🏆 CLASSEMENTS',
  'rank.close': '✕ FERMER',
  'rank.name': 'VOTRE PSEUDO',
    'rank.namePlaceholder': 'Tape ton pseudo pour jouer',
  'rank.online': 'EN LIGNE — MEILLEURS D’ABORD',
  'rank.refresh': '↻ ACTUALISER',
  'rank.local': 'SUR CETTE MACHINE',
  'rank.emptyLocal': 'Rien encore. Finissez une partie et elle atterrit ici.',
  'rank.emptyOnline': 'Le tableau est vide. Soyez le premier.',
  'rank.checking': 'Vérification…',

  'share.close': 'FERMER',
  'share.generate': 'INVITER À UNE PARTIE',
  'share.placeholder': 'Votre code apparaîtra ici',
  'share.copied': 'Copié. Envoyez-le à qui vous voulez inviter.',
  'join.placeholder': 'J’AI UN CODE',
  'join.title': 'REJOINDRE UNE PARTIE',
  'join.label': 'Code de la partie',

  'lang.title': 'LANGUE',
  'lang.note': 'L’anglais est l’original. Tout le reste en est une traduction.',

  // --- shared match codes --------------------------------------------------
  'code.noCode': 'Collez d’abord un code.',
  'code.tooLong': 'C’est bien trop long pour un code de partie.',
  'code.notACode': 'Ça ne ressemble pas à un code de partie.',
  'code.version': 'Ce code vient d’une autre version.',
  'code.corrupt': 'Code corrompu.',
  'code.mode': 'Ce code nomme un mode que cette version n’a pas.',

  // --- the shared board ----------------------------------------------------
  'lb.checking': 'demande au serveur…',
  'lb.online': 'tableau partagé, en direct',
  'lb.noServer': 'pas de serveur de classement ici',
  'lb.timeout': 'le serveur n’a pas répondu à temps',

  // --- what the gorillas shout --------------------------------------------
  'bubble.fireInTheHole': 'ATTENTION DEVANT !',
  'bubble.leap': 'JE PASSE !',
  'bubble.uavOnline': 'DRONE ENNEMI EN LIGNE',
  'bubble.headshot': 'BOUM, EN PLEIN DEDANS !',
  'bubble.extraLife': 'VIE EXTRA !',
  'bubble.mushroomSaved': 'LE CHAMPIGNON A TENU !',
  'bubble.boomerangBack': 'IL EST REVENU !',
  'bubble.boomerangLost': 'IL N’EST PAS REVENU',

  // --- the caption after a kill -------------------------------------------
  'wasted.subtitle': 'Le vent se fiche pas mal de vos plans.',

  // --- the sky -------------------------------------------------------------
  'banner.0': 'MANGEZ PLUS DE BANANES',
  'banner.1': 'LÂCHEZ LE SINGE !',
  'banner.2': 'UNE BANANE PRÉSIDENTE',
  'banner.3': 'CETTE BANNIÈRE MENT',
  'banner.4': 'ENVOYEZ DES BANANES',
  'banner.5': 'ENCORE RATÉ',
  'banner.6': 'CÂLINS GRATUITS',
  'banner.7': 'AU SECOURS, JE SUIS DANS UN JEU',
  'banner.8': 'VICE CITY — À 4 MINUTES',
  'banner.9': 'LEONIDA : L’AUTRE FLORIDE',
  'banner.10': 'SORTIE EN 2027. SANS DOUTE.',

  // --- the splash ----------------------------------------------------------
  'tip.0': 'ASTUCE : LE VENT SE FICHE PAS MAL DE VOS PLANS.',
  'tip.1': 'ASTUCE : L’APERÇU NE COMPTE JAMAIS LE VENT. C’EST TOUT L’INTÉRÊT.',
  'tip.2': 'ASTUCE : UNE BANANE QUI REDESCEND RESTE UNE BANANE.',
  'tip.3': 'ASTUCE : UNE GRENADE N’A PAS BESOIN DE TOUCHER QUELQU’UN.',
  'tip.4': 'ASTUCE : SI L’AUTRE GORILLE DORT, TIREZ.',
  'tip.5': 'ASTUCE : QUELQU’UN DEVRA NETTOYER CET HORIZON.',

  // --- species -------------------------------------------------------------
  'species.gorilla': 'GORILLE',
  'species.chimp': 'CHIMPANZÉ',
  'species.orangutan': 'ORANG-OUTAN',
  'species.baboon': 'BABOUIN',
  'species.panda': 'PANDA',
  'species.bear': 'OURS BRUN',
  'species.rhino': 'RHINOCÉROS',
  'species.bonobo': 'BONOBO',
  'species.gibbon': 'GIBBON',
  'species.mandrill': 'MANDRILL',
  'species.hippo': 'HIPPOPOTAME',
  'species.duck': 'CANARD',
  'species.frog': 'GRENOUILLE',

  // --- accessories ---------------------------------------------------------
  'accessory.cap': 'CASQUETTE',
  'accessory.beanie': 'BONNET',
  'accessory.tophat': 'HAUT-DE-FORME',
  'accessory.crown': 'COURONNE',
  'accessory.viking': 'CASQUE VIKING',
  'accessory.bow': 'NŒUD ROSE',
  'accessory.shades': 'LUNETTES DE SOLEIL',
  'accessory.patch': 'CACHE-ŒIL',
  'accessory.scarf': 'ÉCHARPE',
  'accessory.bowtie': 'NŒUD PAPILLON',
  'accessory.chain': 'CHAÎNE EN OR',

  // --- gestures ------------------------------------------------------------
  'antic.scratch': 'GRIFFOUILLIS',
  'antic.head': 'SE GRATTE LA TÊTE',
  'antic.chest': 'TAPE SON TORSE',
  'antic.wave': 'SALUT',
  'antic.pick': 'DOIGT DANS LE NEZ',
  'antic.shrug': 'HAUSSE LES ÉPAULES',
  'antic.stretch': 'S’ÉTIRE',
  'antic.shake': 'SE SECOUE',
  'antic.clap': 'APPLAUDIT',
  'antic.flex': 'MONTRE SES MUSCLES',

  // --- modes ---------------------------------------------------------------
  'mode.modern.name': 'MODERNE',
  'mode.modern.blurb': 'Spéciaux, gestes, ciel et succès.',
  'mode.classic.name': 'CLASSIQUE',
  'mode.classic.blurb': 'Ni spéciaux, ni gestes, ni ciel, ni succès.',
  'mode.demolition.name': 'DÉMOLITION',
  'mode.demolition.blurb': 'Des cratères qui font tomber toute une tour.',
  'mode.lunar.name': 'GRAVITÉ LUNAIRE',
  'mode.lunar.blurb': 'Un tiers de la force.',
  'mode.weather.name': 'MÉTÉO',
  'mode.weather.blurb': 'Pluie, neige et rafales.',
  'mode.quake.name': 'SÉISME',
  'mode.quake.blurb': 'Les immeubles montent et descendent sous vos pieds.',

  // --- specials ------------------------------------------------------------
  'special.flare.name': 'FUSÉE',
  'special.flare.hint': 'L’aperçu va deux fois plus loin.',
  'special.heavy.name': 'LOURDE',
  'special.heavy.hint': 'Le vent ne la bouge presque pas.',
  'special.fat.name': 'GROS CHARGE',
  'special.fat.hint': 'Un cratère bien plus grand.',
  'special.lunar.name': 'LUNAIRE',
  'special.lunar.hint': 'Pas de vent. Cratère énorme.',
  'special.grenade.name': 'GRENADE',
  'special.grenade.hint': 'Rebondit et explose à retardement.',
  'special.drone.name': 'DRONE',
  'special.drone.hint': 'Passe au-dessus et le marque.',
  'special.leap.name': 'LE SAUT',
  'special.leap.hint': 'Saute à la place de l’adversaire.',
  'special.shield.name': 'BOUCLIER',
  'special.shield.hint': 'Arrête un tir adverse.',
  'social.title': 'DITES-LE À QUELQU’UN',
  'social.whatsapp': 'Partager sur WhatsApp',
  'social.telegram': 'Partager sur Telegram',
  'social.facebook': 'Partager sur Facebook',
  'social.x': 'Partager sur X',
  'social.instagram': 'Envoyer sur Instagram — ouvre le partage du téléphone',
  'social.copy': 'Copier le lien',
  'toast.copied': '🔗 Lien copié',
  'toast.copyFailed': 'Le navigateur n’a pas voulu le copier',
  'special.pick': 'CHOISISSEZ-EN UN',
  'special.spring.name': 'RESSORT',
  'special.spring.hint': 'Montez dessus et dansez.',
  'special.mushroom.name': 'CHAMPIGNON',
  'special.mushroom.hint': 'Encaisse le coup qui vous tuerait.',

  'toast.crateSpecial': '📦 {name} +1 — à vous aussi la manche suivante',
  'toast.crateTheirs': '📦 {who} prend {name}',
  'toast.crateLife': '❤ VIE EXTRA — tu encaisses un coup de plus',
  'toast.crateLifeTheirs': '❤ {who} prend une vie extra',
  'toast.award': '🏆 SUCCÈS ! {names}',
  'setup.cpu': 'DIFFICULTÉ DE L’ORDI',
  'setup.cpuEasy': 'FACILE',
  'setup.cpuNormal': 'NORMALE',
  'setup.cpuHard': 'DIFFICILE',
  'rotate.title': 'TOURNEZ LE TÉLÉPHONE',
    'rotate.body': 'La partie se joue sur le côté : tournez le téléphone pour continuer.',
  'setup.duel': 'COMMENT VOUS JOUEZ À DEUX',
  'duel.code': '🔗 CHACUN SUR SON PC / TÉLÉPHONE',
  'duel.hotseat': '⌨️ MÊME ORDINATEUR',
  'share.waiting': 'Envoyez-lui le code. Il vous en renvoie un.',
  'share.invite': 'Copiez le code et envoyez-le à qui vous voulez inviter.',
  'share.joined': 'Vous êtes dedans. Vous jouez en premier.',
  'share.roomOpen': 'La salle est ouverte : ce code en est la porte, et vous jouez en direct, sans codes à se passer.',
  'share.roomBack': 'Ton rival est là.',
  'share.roomGone': 'Ton rival est parti. La salle reste ouverte et sa place est libre.',
  'share.roomLost': 'La connexion est tombée. La partie continue sur cet appareil.',
  'code.inviteLength': 'Un code d’invitation fait 8 caractères, 4 et 4.',
  'code.inviteLetters': 'Ce code a un caractère qui ne peut pas y être.',
  'code.inviteCheck': 'Ce code ne tombe pas juste : vérifiez une lettre.',
  'special.ball.name': 'LA BALLE',
  'special.ball.hint': 'Parfois c’est une balle.',
  'special.boomerang.name': 'BOOMERANG',
  'special.boomerang.hint': 'Reviens dans ta main sans user la charge.',
  'toast.ball': '{icon} {name} !',
  'ball.basket': 'BALLON DE BASKET',
  'ball.football': 'BALLON DE FOOT',
  'ball.rugby': 'BALLON DE RUGBY',
  'ball.tennis': 'BALLE DE TENNIS',

  // --- achievements --------------------------------------------------------
  'ach.first-blood.name': 'PREMIER SANG',
  'ach.first-blood.hint': 'Touchez avec votre première banane.',
  'ach.round-won.name': 'MANCHE GAGNÉE',
  'ach.round-won.hint': 'Gagnez une manche.',
  'ach.butterfingers.name': 'MAINS DE BEURRE',
  'ach.butterfingers.hint': 'Se toucher soi-même compte aussi.',
  'ach.sharpshooter.name': 'TIREUR D’ÉLITE',
  'ach.sharpshooter.hint': 'Touchez trois fois de suite.',
  'ach.match-won.name': 'PARTIE GAGNÉE',
  'ach.match-won.hint': 'Gagnez une partie.',
  'ach.cpu-slayer.name': 'MASSACREUR D’ORDI',
  'ach.cpu-slayer.hint': 'Gagnez une partie contre l’ordinateur.',
  'ach.moon-shot.name': 'TIR LUNAIRE',
  'ach.moon-shot.hint': 'Faites passer une banane devant la lune.',
  'ach.sky-watcher.name': 'GUETTEUR DU CIEL',
  'ach.sky-watcher.hint': 'Attrapez trois choses différentes qui traversent le ciel.',
  'ach.flawless.name': 'SANS FAUTE',
  'ach.flawless.hint': 'Gagnez une partie sans perdre une seule manche.',
  'ach.veteran.name': 'VÉTÉRAN',
  'ach.veteran.hint': 'Gagnez trois parties.',
  'ach.thrower.name': 'LANCEUR',
  'ach.thrower.hint': 'Lancez 50 bananes.',
  'ach.rounds-10.name': 'DIX MANCHES',
  'ach.rounds-10.hint': 'Gagnez dix manches.',
  'ach.sharpshooter-plus.name': 'ŒIL DE LYNX',
  'ach.sharpshooter-plus.hint': 'Touchez six fois de suite.',
  'ach.moon-3.name': 'ASTROPHYSICIEN',
  'ach.moon-3.hint': 'Passez trois fois devant la lune avec une banane.',
  'ach.cpu-3.name': 'EN FEU',
  'ach.cpu-3.hint': 'Battez l’ordinateur trois fois.',
  'ach.flawless-3.name': 'INTOUCHABLE',
  'ach.flawless-3.hint': 'Gagnez trois parties sans perdre une manche.',
  'ach.veteran-2.name': 'LÉGENDE',
  'ach.veteran-2.hint': 'Gagnez cinq parties.',
  'ach.scavenger.name': 'CHAROGNARD',
  'ach.scavenger.hint': 'Ouvrez cinq caisses.',
  'ach.wall.name': 'LE MUR',
  'ach.wall.hint': 'Levez le bouclier cinq fois.',
  'ach.arsenal.name': 'ARSENAL',
  'ach.arsenal.hint': 'Utilisez six spéciaux différents.',
  'ach.bare-handed.name': 'MAINS NUES',
  'ach.bare-handed.hint': 'Gagnez une partie sans rien dépenser.',
  'ach.room-won.name': 'EN DIRECT',
  'ach.room-won.hint': 'Gagnez une partie dans un salon.',
  'ach.room-3.name': 'VOISINAGE',
  'ach.room-3.hint': 'Gagnez trois parties dans des salons.',
  'ach.by-mail.name': 'PAR CORRESPONDANCE',
  'ach.by-mail.hint': 'Gagnez un duel par code.',
  'ach.boomerang-back.name': 'LE RETOUR',
  'ach.boomerang-back.hint': 'Rattrapez votre boomerang trois fois.',
};
